import { Playground, Props } from 'docz';
import Component from 'react-component-component';
import { Alert, Button } from "../../../../../src";
import * as React from 'react';
export default {
  Playground,
  Props,
  Component,
  Alert,
  Button,
  React
};